<footer class="bg-secondary-main text-flats-white">
  <nav>
    <ul></ul>
  </nav>
</footer>
